import { m } from 'motion/react';

import { containerVariants, itemVariantsNoY } from '../../utils/framer';
import KIAImage from './ui/image/KIAImage';
import KiaImagePlaceholder from './ui/KiaImagePlaceholder';
import LinkButton from './ui/LinkButton';

type ContentColumn = {
  title?: string;
  text: string;
  titleClasses?: string;
  textClasses?: string;
  textContainerClasses?: string;
  image: {
    src: string;
    alt: string;
    sizes?: string;
    className?: string;
  };
  link?: {
    url: string;
    text: string;
  };
};

interface ContentColumnsBlockProps {
  columns: ContentColumn[];
}

const gridColsMap: Record<number, string> = {
  1: 'lg:grid-cols-1',
  2: 'lg:grid-cols-2',
  3: 'lg:grid-cols-3',
  4: 'lg:grid-cols-4',
};

const ContentColumnsBlock = ({ columns }: ContentColumnsBlockProps) => {
  if (!columns || columns.length < 1) return null;
  const gridColsClass = gridColsMap[columns.length] || 'lg:grid-cols-3';
  return (
    <m.ul
      initial="hidden"
      whileInView="visible"
      key={`${columns[0].text}`}
      viewport={{ once: true, margin: '-100px' }}
      variants={containerVariants}
      className={`grid grid-cols-1 ${gridColsClass} gap-14 md:gap-6 w-full`}
    >
      {columns.map((column, index) => {
        return (
          <m.li
            variants={itemVariantsNoY}
            key={`${index}-${column.title || 'col'}`}
            className="flex flex-col gap-4 lg:gap-8"
          >
            <div className="w-full">
              {column.image.src === 'placeholder' ? (
                <KiaImagePlaceholder className="max-w-full max-h-full aspect-[4/3]" />
              ) : (
                <KIAImage
                  {...column.image}
                  className={`aspect-[4/3] object-cover ${column.image.className || ''}`}
                />
              )}
            </div>
            <div
              className={`flex flex-col gap-3 lg:gap-4 w-full h-full ${column.textContainerClasses || ''}`}
            >
              {column.title ? (
                <h3
                  className={`font-semibold antialiased ${column.titleClasses || ''}`}
                >
                  {column.title}
                </h3>
              ) : null}
              <p
                className={`${column.textClasses || ''}`}
                dangerouslySetInnerHTML={{ __html: column.text }}
              />
              {column.link.url ? (
                <div>
                  <LinkButton
                    className="mt-4 mx-auto"
                    url={column.link.url}
                    text={column.link.text}
                  />
                </div>
              ) : null}
            </div>
          </m.li>
        );
      })}
    </m.ul>
  );
};

export default ContentColumnsBlock;
